export const typeOptions = [
  { value: "", label: "Select Type" },
  { value: "paragraph", label: "Paragraph" },
  { value: "product", label: "Product" },
  { value: "image", label: "Image" },
  { value: "video", label: "Video" },
  { value: "code", label: "Code" },
  { value: "list", label: "List" },
  { value: "table", label: "Table" },
  { value: "quote", label: "Quote" },
  { value: "embed", label: "Embed" },
];

export const listStyleOptions = [
  { value: "", label: "Select Style" },
  { value: "ordered", label: "Ordered" },
  { value: "unordered", label: "UnOrdered" },
];

export const paragraphTypeOption = [
  { value: "", label: "Select Type" },
  { value: "text", label: "Text" },
  { value: "html", label: "HTML" },
];
